export interface EnvironmentData {
  url: string;
  userAgent: string;
  viewport: { width: number; height: number };
  screen: { width: number; height: number };
  devicePixelRatio: number;
  language: string;
  timezone: string;
  online: boolean;
  cookiesEnabled: boolean;
  platform: string;
  timestamp: string;
  pageTitle: string;
  referrer: string;
}

export function getEnvironment(): EnvironmentData {
  return {
    url: window.location.href,
    userAgent: navigator.userAgent,
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    screen: {
      width: screen.width,
      height: screen.height,
    },
    devicePixelRatio: window.devicePixelRatio,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    online: navigator.onLine,
    cookiesEnabled: navigator.cookieEnabled,
    platform: navigator.platform,
    timestamp: new Date().toISOString(),
    pageTitle: document.title,
    referrer: document.referrer,
  };
}
